import { getGoldSilverCities, getGoldSilverCitiesAndStates, getGoldSilverStates } from "@/component/GoldSilver/cityList";



export function useCityList() {
  return getGoldSilverCities();
}

export function useCityAndStateList() {
  return getGoldSilverCitiesAndStates();
}

export function useStateList() {
  return getGoldSilverStates();
}
